import {createAsyncThunk} from '@reduxjs/toolkit'
import {createTicket} from 'airship/clients/zendesk/index'

export const createTicketThunk = createAsyncThunk('createTicket', createTicket)
